__turbopack_context__.v({
  "buttonRows": "StyledConstants-module__5XIJnW__buttonRows",
  "buttonTabs": "StyledConstants-module__5XIJnW__buttonTabs",
  "dot": "StyledConstants-module__5XIJnW__dot",
  "dotsContainer": "StyledConstants-module__5XIJnW__dotsContainer",
  "name": "StyledConstants-module__5XIJnW__name",
  "profile": "StyledConstants-module__5XIJnW__profile",
  "quote": "StyledConstants-module__5XIJnW__quote",
  "reviewItem": "StyledConstants-module__5XIJnW__reviewItem",
  "reviewsContainer": "StyledConstants-module__5XIJnW__reviewsContainer",
  "scrollContainer": "StyledConstants-module__5XIJnW__scrollContainer",
});
